<template>
	<div v-if="subscription != undefined">
		<div class="data-item" v-if="subscription.id != undefined">
			<div class="label">
				<strong>{{ $t("id") }}</strong>
			</div>
			<div class="value" style="width: 350px">
				<el-input v-model="subscription.id" :disabled="true" />
			</div>
		</div>
		<div class="data-item">
			<div class="label">
				<strong>{{ $t("name") }}</strong>
			</div>
			<div class="value" style="width: 350px" v-if="editable">
				<el-input
					v-model="subscription.name"
					:disabled="!editable || subscription.name == 'prova gratuita'"
					:placeholder="$t('name')"
					@input="$emit('change', 'name')"
					:class="{ error: error && error.indexOf('name') > -1 }"
					style="width: 100%"
				/>
			</div>
			<div v-else class="value" style="padding: 7px">
				<span>{{ subscription.name }}</span>
			</div>
		</div>
		<div class="data-item">
			<div class="label">
				<strong>{{ $t("price") }}</strong>
			</div>
			<div class="value" style="width: 350px; display: flex; background-color: white" v-if="editable">
				<el-input-number
					v-model="subscription.price"
					@change="$emit('change')"
					style="width: 100%"
					:min="0"
					:precision="2"
					:disabled="freeTrial"
				/>
				<!--<span style="margin-top: auto; margin-bottom: auto; padding: 10px;">{{getCurrency(subscription.currency)}}</span>-->
			</div>
			<div v-else class="value" style="padding: 7px">
				<span>{{ "€ " + subscription.price.toFixed(2) }}</span>
			</div>
		</div>
		<div class="data-item">
			<div class="label">
				<strong>{{ $t("duration-month") }}</strong>
			</div>
			<div class="value" style="width: 350px" v-if="editable">
				<el-input-number
					v-model="subscription.duration_month"
					:min="0"
					style="width: 100%"
					:disabled="!editable || freeTrial"
					@change="() => $emit('change')"
					:class="{ error: error && error.indexOf('duration') > -1 }"
				/>
			</div>
			<div v-else class="value" style="padding: 7px">
				<span>{{ subscription.duration_month }}</span>
			</div>
		</div>
		<div class="data-item">
			<div class="label">
				<strong>{{ $t("area") }}</strong>
			</div>
			<div class="value" style="width: 350px" v-if="editable">
				<div style="display: flex">
					<el-select
						v-model="subscription.areas"
						style="width: 100%"
						multiple
						filterable
						value-key="id"
						:placeholder="$t('area')"
						@change="() => $emit('change')"
						:disabled="!editable || source == 'edit'"
					>
						<el-option v-for="area of areas" :key="area.id" :label="area.name" :value="area" />
					</el-select>
					<el-popover
						v-if="source == 'edit'"
						placement="top-start"
						width="200"
						trigger="hover"
						:content="$t('subscription-options-cant-editable')"
					>
						<div slot="reference">
							<md-button class="md-icon-button"><i class="el-icon-info"/></md-button>
						</div>
					</el-popover>
				</div>
			</div>
			<div v-else class="value" style="padding: 7px">
				<div v-for="item of subscription.areas" :key="item.id">
					{{ item.name }}
				</div>
			</div>
		</div>
		<div class="data-item" style="margin-top: 20px">
			<div class="label">
				<strong>{{ $t("ticketing-service") }}</strong>
			</div>
			<div class="value" style="width: 235px" v-if="editable">
				<el-switch
					:disabled="!editable || freeTrial"
					v-model="subscription.ticketing"
					@change="$emit('change')"
					active-color="#13ce66"
				/>
			</div>
			<div v-else class="value">
				{{ subscription.ticketing ? $t("yes-ticketing") : $t("not-ticketing") }}
			</div>
		</div>
		<div class="data-item" style="margin-top: 20px">
			<div class="label">
				<strong>{{ $t("visible") }}</strong>
			</div>
			<div class="value" style="width: 235px" v-if="editable">
				<el-switch
					@change="$emit('change')"
					:disabled="!editable"
					v-model="subscription.visible"
					active-color="#13ce66"
				/>
			</div>
			<div v-else class="value">
				{{ subscription.visible ? $t("visible") : $t("hidden") }}
			</div>
		</div>
		<div v-if="subscription.id != undefined">
			<el-divider style="width: 80%" />
			<div class="data-item">
				<div class="label">
					<strong>{{ $t("active-from") }}</strong>
				</div>
				<div class="value">
					<span>{{ moment(subscription.created_at).format("DD/MM/YYYY HH:mm") }}</span>
				</div>
			</div>
			<div class="data-item">
				<div class="label">
					<strong>{{ $t("last-update") }}</strong>
				</div>
				<div class="value">
					<span>{{ moment(subscription.updated_at).format("DD/MM/YYYY HH:mm") }}</span>
				</div>
			</div>
			<div class="data-item" v-if="subscription.deleted_at != undefined">
				<div class="label">
					<strong>{{ $t("deleted-at") }}</strong>
				</div>
				<div class="value">
					<span>{{ moment(subscription.deleted_at).format("DD/MM/YYYY HH:mm") }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from "moment"
import axios from "axios"
import { getCurrency } from "@/utils/utils"
export default {
	name: "subscriptions-form",
	props: ["subscription", "error", "editable", "source"],
	data() {
		return {
			areas: [],
			freeTrial: true
		}
	},
	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/areas/", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				this.areas = res.data.areas
			})
			.catch(err => console.error(err))

		this.checkFreeTrial()
	},
	methods: {
		moment,
		getCurrency,
		checkFreeTrial: function() {
			if (this.subscription.name == "prova gratuita") {
				this.freeTrial = true
			} else {
				this.freeTrial = false
			}
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-form";

.error {
	border: 1px solid red;
}
</style>
